import React, { useState, useContext, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { Context } from "./context";
import getMyTheme from "../../src/theme";
import { isBrowser } from "./util";
import Montserrat from "typeface-montserrat";

const getTheme = myTheme =>
  createMuiTheme({
    app: myTheme,
    windowHeight: myTheme.height,
    windowWidth: myTheme.width,
    typography: {
      fontFamily: "Montserrat, Roboto, Helvetica, Arial, sans-serif"
    },
    palette: {
      type: myTheme.type,
      text: {
        primary: myTheme.type === "dark" ? "#d9d7e0" : "#36313d",
        secondary: myTheme.type === "dark" ? "#b5b3bb" : "#716680"
      },
      background: {
        paper: myTheme.type === "dark" ? "#34404c" : "rgb(255,255,255)"
      }
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          "@font-face": [Montserrat]
        }
      }
    }
  });

const ThemeProvider = props => {
  const [prevHeight, setPrevHeight] = useState(0);
  const [prevWidth, setPrevWidth] = useState(0);
  const [hasRan, setHasRan] = useState(false);
  const {
    state: { theme }
  } = useContext(Context);

  const myTheme = getMyTheme(theme);
  const updateScreenSize = () => {
    setPrevHeight(window.innerHeight);
    setPrevWidth(window.innerWidth);
  };

  useEffect(() => {
    if (isBrowser) {
      if (!hasRan) {
        setHasRan(true);
        updateScreenSize();
      }
      window.addEventListener("resize", updateScreenSize);
      return () => {
        window.removeEventListener("resize", updateScreenSize);
      };
    }
  }, [prevHeight, hasRan]);

  return (
    <MUIThemeProvider
      theme={getTheme({ ...myTheme, height: prevHeight, width: prevWidth })}
    >
      <CssBaseline />
      {props.children}
    </MUIThemeProvider>
  );
};

export default ThemeProvider;
